import { Button, Form, Input, Table, Card } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import _ from 'lodash';

const EditableContext = React.createContext(null);

const EditableRow = ({ ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({
        ...record,
        ...values,
      });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };
  let childNode = children;
  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children[1] ? children : '-' }
      </div>
    );
  }
  return <td {...restProps}>{childNode}</td>;
};

const PartnerFarewellTable = ({ welfares }) => {
  const [dataSource, setDataSource] = useState(
    welfares.map((row, i) => ({ key: i, ...row }))
  );

  const json = dataSource.map( row => _.omit(row, ['key']))

  const [count, setCount] = useState(dataSource.length);
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };
  const defaultColumns = [
    {
      title: 'name',
      dataIndex: 'name',
      editable: true,
    },
    {
      title: 'amount',
      dataIndex: 'amount',
      editable: true,
    },
    {
      title: 'startMonthOffset',
      dataIndex: 'startMonthOffset',
      editable: true,
    },
    {
      title: 'intRate',
      dataIndex: 'intRate',
      editable: true,
    },

    {
      title: 'minpayAmount',
      dataIndex: 'minpayAmount',
      editable: true,
    },
    {
      title: 'minpayRate',
      dataIndex: 'minpayRate',
      editable: true,
    },
    {
      title: 'installTerm',
      dataIndex: 'installTerm',
      editable: true,
    },
    {
      title: 'installAmount',
      dataIndex: 'installAmount',
      editable: true,
    },
    {
      title: '',
      align: 'center',
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <DeleteOutlined onClick={() => handleDelete(record.key)}/>
        ) : null,
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });

  return (
    <div>
      <Table
        components={components}
        bordered
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
      <Button
        onClick={handleAdd}
        type="primary"
        style={{
          marginTop: 8,
          marginBottom: 8,
        }}
      >
        <PlusOutlined />
      </Button>
      <Card style={{ marginBottom: 16 }}>
        <pre>{JSON.stringify(json, null, 4)}</pre>
      </Card>
      <input type="hidden" name='partner[welfares]' value={JSON.stringify(json)} />
    </div>
  );
};
export default PartnerFarewellTable;
